import Button from "../../../components/elements/form/Button";
import { FaArrowRight, FaPlus } from "react-icons/fa";

type IBranchActions = {
  onRegisterBranch: () => void;
  onJoinBranch: () => void;
  isLoading: boolean;
};

export const BranchActions = ({
  onRegisterBranch,
  onJoinBranch,
  isLoading,
}: IBranchActions) => {
  return (
    <div className="flex items-center mt-6">
      <div className="mx-2">
        <Button
          icon={<FaPlus />}
          title="Register Branch"
          loading={isLoading}
          onHandler={onRegisterBranch}
          className="bg-primary-500 hover:bg-primary-900 text-white w-fit rounded-lg"
        />
      </div>
      <div className="mx-2">
        <Button
          icon={<FaArrowRight />}
          title="Join Branch"
          loading={isLoading}
          onHandler={onJoinBranch}
          className="bg-white hover:bg-white/10 border border-primary-500 text-primary-500 w-fit rounded-lg"
        />
      </div>
    </div>
  );
};
